<!-- Paymen Detail Section-->
<div class="row">
    <div class="col-sm">
        <div class="flex-item agreement-margin"><span class="highlight-text">PAYMENT DETAILS</span>
            <div class="basic-icon">
            </div>
        </div>
    </div>
</div>
<div class="row">



    <div class="col-sm">

        <label class="lable-title">
            PAYMENT METHOD
        </label>
        <p></p>
        <ng-container *ngIf="paymentMethod">
            <p class="paragraph-text payment-method">Digital Wallet</p>
            <p class="paragraph-text">{{paymentMethod?.out_card_scheme}}</p>
            <p class="paragraph-text">{{paymentMethod?.out_account_name}}</p>
            <p class="paragraph-text">{{paymentMethod?.out_masked_card_number}} Expires {{paymentMethod?.out_expiry}}
            </p>
        </ng-container>

    </div>


    <div class="col-sm">
    </div>


    <div class="col-sm">
        <button (click)="editPaymentDetails($event)" class="button button-red button-mid edit-enduser">
            Edit Payment Details</button>
        <br />
        <br />
    </div>
</div>